// removed by extract-text-webpack-plugin
module.exports = {"contentWrapper":"contentWrapper--RfMyu","content":"content---QkHd contentWrapper--AHarZ","title":"title--3yILv title--3f9JQ","detail":"detail--204dV contentArea--SiMDT","section":"section--2payy","mainContent":"mainContent--3hA_3","field":"field--3t2GA field--3-Kdn","fieldLabel":"fieldLabel--P9Uqz calderDark--1bp9m"};


//////////////////
// WEBPACK FOOTER
// ./components/NewsItem/styles.css
// module id = 1065
// module chunks = 2